<template>
  <div class="default-layout"
       :class="layoutClasses">
      <Header />
    <div v-if="$mq !== 'mobile'"
         class="sidebar">
      <Feed />
    </div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
  import Header from '@/components/Header/Header.vue'
  import Feed from '@/components/Feed/Feed.vue'

  export default {
    components: {
      Header,
      Feed
    },

    computed: {
      layoutClasses() {
        return {
          'mobile-layout' : this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .default-layout {
    height: 100%;
  }

  .sidebar {
    position: fixed;
    top: $header-height;
    width: $sidebar-width;
    height: 100%;
    padding: 10px 0 0 20px;
    box-shadow: 2px 0 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
    overflow: hidden;
  }

  .content {
    padding: $header-height 0 0 $sidebar-width;
    min-height: 100%;
    height: 100%;
  }

  .mobile-layout {
    .content {
      padding: 0;
    }
  }
</style>
